import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { graphql, compose, withApollo } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import EditMember from '../../components/EditMember';
import saveMember from '../../mutations/saveMember';
import createSecondaryForAccount from '../../mutations/createSecondaryForAccount';
import standardizeAddress from '../../queries/standardizeAddress';
import { setSuccessMessage, setErrorMessage } from '../../actions/messages';
import { setMemberRequest, removeMemberRequest } from '../../actions';

const validateAddress = client => (
  ({ addressLine1, addressLine2, city, state, zipCode, country }) => (
    client.query({
      query: standardizeAddress,
      variables: {
        input: { addressLine1, addressLine2, city, state, zipCode, country },
      },
      fetchPolicy: 'network-only',
    })
  )
);

export const EditMemberWrapper = props => (
  <EditMember
    validateAddress={validateAddress(props.client)}
    {...props}
  />
);
EditMemberWrapper.propTypes = {
  client: PropTypes.object.isRequired,
};

export const mapStateToProps = ({ memberRequest }) => ({
  memberRequest,
});

export default compose(
  graphql(saveMember, {
    name: 'saveMember',
    options: { notifyOnNetworkStatusChange: true },
  }),
  graphql(createSecondaryForAccount, {
    name: 'createSecondaryForAccount',
    options: { notifyOnNetworkStatusChange: true },
  }),
)(withRouter(connect(mapStateToProps, {
  setMemberRequest,
  removeMemberRequest,
  setSuccessMessage,
  setErrorMessage,
})(withApollo(EditMemberWrapper))));



// WEBPACK FOOTER //
// ./src/app/containers/EditMember/index.js